import { useNavigate, useParams } from 'react-router';
import Frame from '../../uikit/Frame';
import LessonIntro from './LessonIntro';

const LessonIntroPage = () => {
    const { lessonHash = '' } = useParams();
    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate(`/my/lesson/${lessonHash}`);
    };

    return (
        <Frame className="bg-base-100 gap-0">
            <div className="mx-auto w-full max-w-[760px] px-4 py-8">
                <LessonIntro lessonHash={lessonHash} onNavigate={handleNavigate} />
            </div>
            <Frame.Spacer />
        </Frame>
    );
};

export default LessonIntroPage;
